module.exports = __webpack_public_path__ + "static/waivpay-6c4dafd34b8286975b877f325a05b8b1.jpg";